<sz-app-shell>
  <sz-top-bar />

  <div class="session-add-drill">
    <sz-page-title [title]="'session.addDrill.title' | translate" size="xl" [showBack]="true" />

    <sz-search-input
      [placeholder]="'session.addDrill.searchPlaceholder' | translate"
      [ngModel]="searchQuery()"
      (ngModelChange)="setSearch($event)" />

    <div class="session-add-drill__filters">
      <lib-drills-list-type-filter [active]="typeFilter()" (activeChange)="setTypeFilter($event)" />
      <lib-drills-list-tabs [active]="activeTab()" (activeChange)="setTab($event)" />
    </div>

    <sz-section-head [label]="'drills.list.sectionLabel' | translate" [count]="visibleDrills().length" />

    <div class="session-add-drill__items">
      @if (data() === null) {
        <sz-skeleton shape="block" height="64px" />
        <sz-skeleton shape="block" height="64px" />
        <sz-skeleton shape="block" height="64px" />
        <sz-skeleton shape="block" height="64px" />
      } @else {
        @for (drill of visibleDrills(); track drill.id) {
          <lib-drill-list-item [drill]="drill" (select)="select(drill)" />
        } @empty {
          <p class="session-add-drill__empty">{{ 'session.addDrill.empty' | translate }}</p>
        }
      }
    </div>
  </div>

  @if (selectedDrill(); as drill) {
    <sz-bottom-sheet [open]="true" (close)="closeSheet()">
      <div szSheetHeader class="session-add-drill__sheet-header">
        <span class="session-add-drill__sheet-title">{{ drill.name }}</span>
        <span class="session-add-drill__sheet-sub">{{ drill.scoringLabel }}</span>
      </div>
      <div class="session-add-drill__sheet-body">
        <lib-target-runs-form
          [submitLabel]="'session.addDrill.addCta' | translate"
          (targetSubmit)="onRunsTargetSubmit($event)" />
      </div>
    </sz-bottom-sheet>
  }
</sz-app-shell>
